import Layout from "@/components/feature/Layout";
import PageHero from "@/components/base/PageHero";
import SectionHeader from "@/components/base/SectionHeader";
import ExperienceCard from "@/components/base/ExperienceCard";
import CTAPanel from "@/components/base/CTAPanel";

const commercialThemes = [
  {
    title: "Enterprise Applications",
    description: "Development, modernization, and support of enterprise applications across commercial environments.",
  },
  {
    title: "Database & Data Platforms",
    description: "Database engineering and administration for commercial database-backed applications and systems.",
  },
  {
    title: "Microsoft Platforms",
    description: "SharePoint, Power Platform, and workflow solutions delivered within commercial enterprise settings.",
  },
  {
    title: "Web & Digital",
    description: "Web applications, portals, and digital solutions supporting commercial business operations.",
  },
  {
    title: "Systems Integration",
    description: "Application and enterprise-system integration connecting commercial business processes and platforms.",
  },
  {
    title: "Technical Delivery",
    description: "Technical SMEs, implementation, testing, training, and production support for commercial programs.",
  },
];

const commercialExperience = [
  {
    client: "Commercial Enterprise — Application & Data Services",
    country: "United States",
    icon: "ri-building-3-line",
    project: "Enterprise Application, Database, and Platform Services",
    scope: "Mitaja Corporation provided subcontract technology services supporting commercial enterprise environments, including application-related technical services and enterprise platform support.",
    capabilities: [
      "Application Development",
      "Application Modernization",
      "Database Systems",
      "Enterprise Applications",
      "Technical Delivery",
    ],
    technologies: [
      "Enterprise Applications",
      "Database Systems",
      "Microsoft Platforms",
    ],
  },
  {
    client: "Commercial Enterprise — Digital & Workflow Solutions",
    country: "United States",
    icon: "ri-flow-chart",
    project: "Digital, Workflow, and Web Solutions",
    scope: "Mitaja Corporation provided subcontract technology services supporting commercial digital initiatives, including workflow solutions and web/application services.",
    capabilities: [
      "Web & Digital Solutions",
      "Workflow Automation",
      "SharePoint",
      "Power Platform",
      "Application Support",
    ],
    technologies: [
      "SharePoint",
      "Power Apps",
      "Power Automate",
      "Power BI",
      "Web Applications",
    ],
  },
];

export default function CommercialExperience() {
  return (
    <Layout>
      <PageHero
        title="Commercial Experience"
        subtitle="Experience · Commercial Enterprise"
        description="Mitaja Corporation provides technology delivery within commercial enterprise environments, spanning applications, databases, Microsoft platforms, web and digital solutions, and systems integration."
        size="lg"
      />

      <section className="section-padding bg-white">
        <div className="container-page">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
            {commercialExperience.map((exp) => (
              <ExperienceCard key={exp.client} {...exp} />
            ))}
          </div>
        </div>
      </section>

      <section className="section-padding bg-background-100">
        <div className="container-page">
          <SectionHeader
            title="Commercial Delivery Themes"
            description="Capability areas delivered within commercial enterprise environments."
          />
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
            {commercialThemes.map((theme) => (
              <div key={theme.title} className="card-base p-6">
                <h3 className="text-lg font-bold text-foreground-900 mb-2">
                  {theme.title}
                </h3>
                <p className="text-sm text-foreground-600 leading-relaxed">
                  {theme.description}
                </p>
              </div>
            ))}
          </div>
        </div>
      </section>

      <CTAPanel
        title="Applying Enterprise Experience to Your Environment"
        description="Mitaja brings commercial and government technology experience together to support enterprise partners across complex technology initiatives."
        primaryAction={{ label: "Explore Capabilities", href: "/capabilities" }}
        secondaryAction={{ label: "Contact Business Development", href: "/contact" }}
        variant="dark"
      />
    </Layout>
  );
}